<template>
  <div class="attr-table">
    <b-row><b-col>Realtime status: </b-col><b-col>{{ realtimeStatus }}</b-col></b-row>
    <b-row><b-col>Passing time: </b-col><b-col>{{ passingTime }}</b-col></b-row>
    <b-row><b-col>Change time: </b-col><b-col>{{ changeTime }}</b-col></b-row>
    <b-row><b-col>Stop name: </b-col><b-col>{{ stopName }}</b-col></b-row>
    <b-row><b-col>Route ID: </b-col><b-col>{{ routeId }}</b-col></b-row>
    <b-row><b-col>Block sequence: </b-col><b-col>{{ blockSequence }}</b-col></b-row>
    <b-row><b-col>Active: </b-col><b-col>{{ active }}</b-col></b-row>
  </div>
</template>

<script>
import mapstore from '@/store/map/mapstore'
import timetable from '@/store/timetable/timetable'
import olf from '@/components/Map/OpenLayersFunctions.js'

export default {
  name: 'VehicleRealtimeDetails',
  components: {},
  data: function () {
    return {
      item: null,
      vehicleRTDetail: null,
      spatialData: null,
      formattedGpsTime: '',
    }
  },
  props: {
    // msg: String
    itemId: { default: null },
  },
  beforeCreate: function () {
    if (!this.$store.state.mapstore) {
      this.$store.registerModule('mapstore', mapstore)
    }
    if (!this.$store.state.timetable) {
      this.$store.registerModule('timetable', timetable)
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },

  mounted() {
    this.fetchVehicleDetail()
    this.interval = setInterval(this.fetchVehicleDetail, 30000)

  },

  watch: {
    runningRouteTunnus: function () {
      this.$emit('vehiclesRoute', this.runningRouteTunnus)
    },
  },
  computed: {
    serverTimestamp() {
      if (this.spatialData != null)
        return olf.formatTimestamp(
          this.spatialData.properties.extraInfo.serverTimestamp
        )
      else return null
    },

    gpsTimestamp() {
      if (this.spatialData != null)
        return olf.formatTimestamp(this.spatialData.properties.gpsTimestamp)
      else return null
    },
    stopName() {
      if (this.spatialData != null) return this.spatialData.properties.stopName
      else return null
    },
    routeId() {
      if (this.spatialData != null) return this.spatialData.properties.routeId
      else return null
    },
    blockSequence() {
      if (this.spatialData != null)
        return this.spatialData.properties.blockSequence
      else return null
    },
    active() {
      if (this.spatialData != null) return this.spatialData.properties.active
      else return null
    },
    realtimeStatus() {
      if (this.spatialData != null) return this.spatialData.properties.realtimeStatus
      else return null
    },
    passingTime() {
      if (this.spatialData != null) return olf.formatTimestamp(this.spatialData.properties.passingTime)
      else return null
    },
    changeTime() {
      if (this.spatialData != null) return olf.formatTimestamp(this.spatialData.properties.changeTime)
      else return null
    },
  },

  methods: {
    fetchVehicleDetail() {
      this.$store.dispatch('mapstore/getVehiclesForTable').then(
        (data) => {
          const found = data.find((i) => i.vehicleId == this.itemId)
          this.vehicleRTDetail = found
          if (this.vehicleRTDetail) {
            this.spatialData = found.spatialData
            this.formattedGpsTime = this.formatTimestamp(
              this.spatialData.properties.gpsTimestamp
            )
          }
        },
        (error) => {
          console.log('Error fetching vehicle details:', error)
        }
      )
    },
    formatTimestamp(timestamp) {
      timestamp = olf.formatTimestamp(timestamp)
      return timestamp
    },
  },
}
</script>
